<div [class]="'d-flex flex-column ' + wrapperClasses()">
  @for (config of configs(); track $index + config.accordionTitle) {
    <!-- Content -->
    <div class="d-flex flex-column">
      <!-- Title Section -->
      <div class="accordion-title d-flex flex-column">
        <div
          class="d-flex flex-row justify-content-space-between align-items-center w-100 pb-low cursor-pointer"
          (click)="toggleDetails($index)"
        >
          <div class="d-flex gap-low align-items-center">
            @if (config.accordionTitle !== '') {
              <common-icon-dp-icon
                [icon]="config.accordionTitle"
                [iconType]="'linear'"
                [iconSize]="'20'"
              ></common-icon-dp-icon>
            }
            <div>{{ config.accordionTitle }}</div>
          </div>
          <common-icon-dp-icon
            [@rotateChevron]="showDetails()[$index] ? 'open' : 'close'"
            [icon]="'Arrow-2-down'"
            [iconType]="'linear'"
            [classes]="'text-onback-medium'"
            [iconSize]="'20'"
          ></common-icon-dp-icon>
        </div>
        <!-- Closed Details -->
        @if (!showDetails()[$index]) {
          <div
            [@showDetails]
            class="d-flex flex-row flex-wrap"
          >
            <ng-container *ngComponentOutlet="config.component; inputs: inputsToPass()[$index]" />
          </div>
        }
        <!-- End Closed Details -->
      </div>
      <!-- End Title Section -->
      <!-- Details -->
      @if (showDetails()[$index]) {
        <div
          [@showDetails]
          class="accordion-details w-100"
        >
          <ng-container *ngComponentOutlet="config.component; inputs: inputsToPass()[$index]" />
        </div>
      }
      <!-- End Details -->
    </div>
    <!-- End Content -->

    <!-- Divider -->
    @if (config.showDivider) {
      <div class="w-100 my-plus border-b-300 border-color-air"></div>
    }
    <!-- End Divider -->
  }
</div>
